/* eslint-disable unicorn/numeric-separators-style */

import { StoryData } from '@storyblok/react'
import { HomeStoryContent } from '../../types/home-story-content'

export const homeStoryFallback: StoryData<HomeStoryContent> = {
  name: 'Home',
  created_at: '2022-08-25T14:53:07.818Z',
  published_at: '2025-11-25T20:13:07.205Z',
  id: 180424826,
  uuid: 'e3977607-836f-42c1-b1cb-89b9d1aa2743',
  content: {
    usp: [
      {
        _uid: '5264f2a5-281e-44ac-9ab1-12730600779c',
        icon: 'cinchCare-servicing',
        link: {
          id: '',
          url: '/car-care/servicing',
          linktype: 'url',
          fieldtype: 'multilink',
          cached_url: '/car-care/servicing',
        },
        text: 'Book your next car service or MOT at over 100 locations nationwide.',
        title: 'Faff-free car servicing',
        component: 'HomeUspSlide',
        _editable:
          '\u003C!--#storyblok#{"name": "HomeUspSlide", "space": "132543", "uid": "5264f2a5-281e-44ac-9ab1-12730600779c", "id": "180424826"}--\u003E',
      },
      {
        _uid: '3545b32c-5736-4cda-b0fc-f468b2c6d0df',
        icon: 'smartphone',
        link: {
          id: '',
          url: '/app',
          linktype: 'url',
          fieldtype: 'multilink',
          cached_url: '/app',
        },
        text: 'Buy your next car in a tap and a swipe, download the mobile app.',
        title: 'Get the app',
        component: 'HomeUspSlide',
        _editable:
          '\u003C!--#storyblok#{"name": "HomeUspSlide", "space": "132543", "uid": "3545b32c-5736-4cda-b0fc-f468b2c6d0df", "id": "180424826"}--\u003E',
      },
      {
        _uid: 'e4c6f3e2-fb4d-4a02-b757-3216418fd6fd',
        icon: 'search',
        link: {
          id: '',
          url: 'https://help.cinch.co.uk/hc/en-gb/articles/29903806800669-How-do-I-set-up-a-search-alert',
          linktype: 'url',
          fieldtype: 'multilink',
          cached_url:
            'https://help.cinch.co.uk/hc/en-gb/articles/29903806800669-How-do-I-set-up-a-search-alert',
        },
        text: 'Set up a search alert to get notified when your perfect car goes on sale.',
        title: 'Be first in line',
        component: 'HomeUspSlide',
        _editable:
          '\u003C!--#storyblok#{"name": "HomeUspSlide", "space": "132543", "uid": "e4c6f3e2-fb4d-4a02-b757-3216418fd6fd", "id": "180424826"}--\u003E',
      },
    ],
    _uid: '97440a25-fa55-4494-b617-667b10e8b43c',
    herov2: [
      {
        _uid: '6bb51dd8-70c6-42aa-ad50-91865474b892',
        image: {
          id: 112364711600274,
          alt: 'test',
          name: '',
          focus: '',
          title: '',
          source: '',
          filename:
            'https://a.storyblok.com/f/132543/750x257/2a568d3fea/black-fri-website-750x257.png',
          copyright: '',
          fieldtype: 'asset',
          meta_data: {
            alt: 'test',
            title: '',
            source: '',
            copyright: '',
          },
          is_external_url: false,
        },
        heading: 'Daily deals',
        heroLink: [
          {
            _uid: '0f7a92f6-75e5-46d0-a02c-e738e0e1c443',
            link: {
              id: '',
              url: '/new-cars/',
              linktype: 'url',
              fieldtype: 'multilink',
              cached_url: '/new-cars/',
            },
            text: 'View cars on offer',
            component: 'LinkWithText',
            _editable:
              '\u003C!--#storyblok#{"name": "LinkWithText", "space": "132543", "uid": "0f7a92f6-75e5-46d0-a02c-e738e0e1c443", "id": "180424826"}--\u003E',
          },
        ],
        component: 'HomeHeroV2',
        subheading: '£250-£1000 off selected cars, with a free 90-day warranty',
        heroPartExchange: [
          {
            _uid: 'c427869a-f76b-4eb5-a5aa-115d2738b0e7',
            label: 'Enter your car registration',
            title: 'Get a free, instant part exchange quote',
            ctaText: 'Start your free valuation',
            component: 'HeroV2PartExchange',
            placeholder: 'Eg. A20 FGG',
            partExTextList: [
              {
                _uid: 'a975f14b-7354-421a-b152-4b646dc9dd5f',
                text: 'Guaranteed price for your car',
                component: 'Text',
                _editable:
                  '\u003C!--#storyblok#{"name": "Text", "space": "132543", "uid": "a975f14b-7354-421a-b152-4b646dc9dd5f", "id": "180424826"}--\u003E',
              },
              {
                _uid: '25509008-77f4-4dc2-9712-ccacd58fc70f',
                text: 'No hidden fees',
                component: 'Text',
                _editable:
                  '\u003C!--#storyblok#{"name": "Text", "space": "132543", "uid": "25509008-77f4-4dc2-9712-ccacd58fc70f", "id": "180424826"}--\u003E',
              },
              {
                _uid: '70b43d7a-a04f-410e-8a04-4cd66178046e',
                text: 'We collect your part ex car',
                component: 'Text',
                _editable:
                  '\u003C!--#storyblok#{"name": "Text", "space": "132543", "uid": "70b43d7a-a04f-410e-8a04-4cd66178046e", "id": "180424826"}--\u003E',
              },
            ],
            _editable:
              '\u003C!--#storyblok#{"name": "HeroV2PartExchange", "space": "132543", "uid": "c427869a-f76b-4eb5-a5aa-115d2738b0e7", "id": "180424826"}--\u003E',
          },
        ],
        rightSideContent: [
          {
            cta: [
              {
                url: 'used-cars?financeType=any&sortingCriteria=11&toPrice=200',
                _uid: '0e1d0fdf-d4e0-444f-9f6a-0291331b3d00',
                type: 'primary',
                label: 'View cars on offer',
                component: 'CtaButton',
              },
            ],
            _uid: 'e2e070f5-0b78-4e47-98ea-9a7607d3885b',
            image: {
              id: 134355165754402,
              alt: 'Red and yellow cars flank a neon sign reading "Winter Bargains" with snowflake icons, set against a vibrant purple background.',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/132543/750x257/2d3715ab40/website-750x257_alt_winter_pr.png',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'Red and yellow cars flank a neon sign reading "Winter Bargains" with snowflake icons, set against a vibrant purple background.',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            heading: 'Bargains \nwithout the faff',
            component: 'HomeHeroCard',
            subheading: '1000s of cars under £199 a month',
          },
        ],
        isHeroPromotional: false,
        isMobileImageShown: true,
        _editable:
          '\u003C!--#storyblok#{"name": "HomeHeroV2", "space": "132543", "uid": "6bb51dd8-70c6-42aa-ad50-91865474b892", "id": "180424826"}--\u003E',
      },
    ],
    partEx: [
      {
        _uid: 'c000a459-55b0-4572-8d43-2aee50858d5a',
        link: 'Find out more about part exchange',
        image: {
          id: 5667847,
          alt: 'a customer smiling in their car',
          name: '',
          focus: null,
          title: '',
          filename:
            'https://a.storyblok.com/f/143588/598x478/f9bf0c0356/part-ex-valuation-image.png',
          copyright: '',
          fieldtype: 'asset',
        },
        label: 'Enter your car registration',
        title: 'Part exchange?',
        ctaText: 'Start your free valuation',
        subtitle: 'Get a free, instant part-ex quote.',
        component: 'PartExSection',
        placeholder: 'E.g. A20FGG',
        _editable:
          '\u003C!--#storyblok#{"name": "PartExSection", "space": "132543", "uid": "c000a459-55b0-4572-8d43-2aee50858d5a", "id": "180424826"}--\u003E',
      },
    ],
    whyCinch: [
      {
        _uid: '8f2aa82e-bddb-4f8b-bb8d-a82d218af4b9',
        cards: [
          {
            _uid: 'ecf148b3-c22a-43c0-a218-0838f9a9c65d',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'With thousands of ',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                    {
                      text: 'cars',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'https://www.cinch.co.uk/used-cars',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                    {
                      text: ' all in one place, you’re sure to find your perfect one. All used cars come with a 90-day warranty and a minimum 6-month MOT for total peace of mind.',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            icon: 'vehicle-front',
            name: 'cars',
            title: 'Great value, high-quality used cars',
            component: 'WhyCinchCard',
            _editable:
              '\u003C!--#storyblok#{"name": "WhyCinchCard", "space": "132543", "uid": "ecf148b3-c22a-43c0-a218-0838f9a9c65d", "id": "180424826"}--\u003E',
          },
          {
            _uid: '805c8891-c1e1-4473-af1c-878283d7307a',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Buy outright or spread the cost with helpful ',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                    {
                      text: 'finance',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: '/car-finance',
                            uuid: null,
                            anchor: null,
                            target: null,
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                    {
                      text: ' options. You can ',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                    {
                      text: 'part exchange',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'https://www.cinch.co.uk/part-exchange',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                    {
                      text: ' and use the value of your old car to help pay for your new one.',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            icon: 'calculator',
            name: 'finance',
            title: 'Choose how you pay',
            component: 'WhyCinchCard',
            _editable:
              '\u003C!--#storyblok#{"name": "WhyCinchCard", "space": "132543", "uid": "805c8891-c1e1-4473-af1c-878283d7307a", "id": "180424826"}--\u003E',
          },
          {
            _uid: 'd66d275e-db99-409c-8668-ce859bd5b275',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Choose ',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                    {
                      text: 'home delivery',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: '/delivery',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                    {
                      text: ' or ',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                    {
                      text: 'collect',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: '/car-collections',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                    {
                      text: " from 100+ convenient locations to pick up your used car – it's up to you.",
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            icon: 'home-delivery',
            name: 'delivery',
            title: 'Delivery or collection available',
            component: 'WhyCinchCard',
            _editable:
              '\u003C!--#storyblok#{"name": "WhyCinchCard", "space": "132543", "uid": "d66d275e-db99-409c-8668-ce859bd5b275", "id": "180424826"}--\u003E',
          },
        ],
        image: {
          id: 5776668,
          alt: 'Why cinch image',
          name: '',
          focus: null,
          title: '',
          filename:
            'https://a.storyblok.com/f/143588/2000x2268/41d124f34e/circle-rylan.png',
          copyright: '',
          fieldtype: 'asset',
        },
        title: 'Why cinch?',
        component: 'WhyCinchSection',
        _editable:
          '\u003C!--#storyblok#{"name": "WhyCinchSection", "space": "132543", "uid": "8f2aa82e-bddb-4f8b-bb8d-a82d218af4b9", "id": "180424826"}--\u003E',
      },
    ],
    component: 'HomePage',
    carsCarousel: [
      {
        _uid: '37a28243-f5a3-4521-968c-114c5ce9406b',
        title: 'Shop new cars',
        sortBy: 'FIRST_PUBLISHED_DATE_DESC',
        priceTo: '35000',
        component: 'CarsCarousel',
        priceFrom: '10000',
        disclaimer: 'Sold by our partner Marshall Motor Group',
        carsCondition: 'new',
        showMonthlyPrices: true,
        showOnlyCinchStock: false,
        financeRepresentativeExample: ['ac7cc910-1443-457b-92d9-476cff208394'],
        _editable:
          '\u003C!--#storyblok#{"name": "CarsCarousel", "space": "132543", "uid": "37a28243-f5a3-4521-968c-114c5ce9406b", "id": "180424826"}--\u003E',
      },
    ],
    newCarsCarouselTab: [
      {
        _uid: 'cf892ce7-b0fe-45f4-8560-966316e38189',
        title: '',
        sortBy: 'FIRST_PUBLISHED_DATE_DESC',
        priceTo: '',
        component: 'CarsCarousel',
        priceFrom: '',
        disclaimer: 'Sold by our partner Marshall Motor Group',
        carsCondition: 'new',
        showMonthlyPrices: false,
        showOnlyCinchStock: false,
        financeRepresentativeExample: [],
        _editable:
          '\u003C!--#storyblok#{"name": "CarsCarousel", "space": "132543", "uid": "cf892ce7-b0fe-45f4-8560-966316e38189", "id": "180424826"}--\u003E',
      },
    ],
    usedCarsCarouselTab: [
      {
        _uid: '511165ad-92da-44e5-98ce-f0bc2717a3b1',
        title: '',
        sortBy: 'FIRST_PUBLISHED_DATE_DESC',
        priceTo: '20000',
        component: 'CarsCarousel',
        priceFrom: '10000',
        disclaimer: '',
        carsCondition: 'used',
        showMonthlyPrices: false,
        showOnlyCinchStock: false,
        financeRepresentativeExample: [],
        _editable:
          '\u003C!--#storyblok#{"name": "CarsCarousel", "space": "132543", "uid": "511165ad-92da-44e5-98ce-f0bc2717a3b1", "id": "180424826"}--\u003E',
      },
    ],
    previewPersonalisedContent: false,
    _editable:
      '\u003C!--#storyblok#{"name": "HomePage", "space": "132543", "uid": "97440a25-fa55-4494-b617-667b10e8b43c", "id": "180424826"}--\u003E',
    personalised: [
      {
        helpMeChoose: [
          {
            _uid: 'b492c62c-e9f6-4e94-b663-c953e7645897',
            body: 'Try our nifty Help Me Choose tool. Answer a few quick questions to find your perfect match.',
            image: {
              id: 6870271,
              alt: 'multiple cars',
              name: '',
              focus: null,
              title: '',
              filename:
                'https://a.storyblok.com/f/143588/2220x1440/eddc06cce0/help-me-choose.png',
              copyright: '',
              fieldtype: 'asset',
            },
            title: 'Not sure what you are looking for?',
            ctaText: 'Help Me Choose',
            heading: 'Narrow down your search',
            component: 'HelpMeChooseSection',
          },
        ],
        valuePropositions: [
          {
            _uid: '29ef7655-a0f6-4c02-9235-7927b346b2a6',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'All our used cars are ',
                      type: 'text',
                    },
                    {
                      text: 'carefully reconditioned',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'https://www.cinch.co.uk/car-inspection',
                            uuid: null,
                            anchor: null,
                            target: null,
                            linktype: 'url',
                          },
                        },
                      ],
                    },
                    {
                      text: ' and have at least six months’ MOT and come with a free 90-day warranty.',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            icon: 'shield',
            heading: 'cinch quality assured for used cars',
            component: 'ValuePropsCard',
          },
          {
            _uid: 'cc8c6ebe-85c2-4124-a70e-ffff4f88cbb7',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Get protection for what matters to you with ',
                      type: 'text',
                    },
                    {
                      text: 'cinchCover.',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'http://www.cinch.co.uk/car-care/cinch-cover',
                            uuid: null,
                            anchor: null,
                            target: null,
                            linktype: 'url',
                          },
                        },
                      ],
                    },
                    {
                      text: ' Keep your used car running and looking as it should, with protection against mechanical, electrical and cosmetic repairs.',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            icon: 'shield-heart',
            heading: 'Caring for your used car',
            component: 'ValuePropsCard',
          },
        ],
      },
    ],
  },
  slug: 'home',
  full_slug: 'home',
  sort_by_date: null,
  position: -20,
  tag_list: [],
  is_startpage: false,
  parent_id: 0,
  meta_data: null,
  group_id: '837246ae-690f-4e5c-9c54-002f7f2da6bf',
  first_published_at: '2022-08-26T15:28:52.094Z',
  lang: 'default',
  alternates: [],
}
